import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import itoBackground from '../../../assets/ito.svg';
import itoDarkBackground from '../../../assets/ito-dark.svg';
import { Box } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
   root: {
      flexGrow: 1,
      justifyContent: 'center',
   },
}));

const ITOnoSpaces = (props) => {
   const classes = useStyles();
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

   return (
      <div className={classes.root}>
         <Box
            sx={{
               width: '100%',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               mt: 6,
            }}
         >
            <img src={prefersDarkMode ? itoDarkBackground : itoBackground} alt="Away" />
         </Box>
      </div>
   );
};

export default ITOnoSpaces;
